import base_ds from "@/services/base_datasource_service";
import request from "@/utils/request";
import { AxiosResponse } from "axios";

export const route_ns = `input_control`;


class InputContolService {
  public crud = base_ds.getBaseCrud(route_ns);

  public async getData(id_cut: string, year: number) {
    const route = route_ns+`?id_cut=${id_cut}&year=${year}`;
    const response: AxiosResponse["data"] = await request({
        url: route,
        method: "get",
      });
    if (response) {
      return response;
    } else {
      return { data: null };
    }
  }

}

export default new InputContolService();
